import { ProfileEbook } from './ProfileEbook'
import { withProfileEbook } from './withProfileEbook'

const Connected = withProfileEbook(ProfileEbook)

export { Connected as ProfileEbook }
